import * as React from 'react';

import { usePaywallReducer } from '~teacher/components/PaywallDialog';
import { QuizzesPaywall } from '~teacher/components/QuizzesPaywall';

import { useImportBySoc, useImportQuizBySocMessageListener } from './hooks';

const DISCOVER_URL = `https://quizshop.co/collections?ref=${window.location.origin}`;

export function Discover() {
  const [{ open: quizLimitPaywallOpen, touch }, paywallDispatch] =
    usePaywallReducer();
  const onCloseQuizLimitPaywall = () => paywallDispatch({ type: 'CLOSE' });

  const { importQuiz } = useImportBySoc({ paywallDispatch });
  useImportQuizBySocMessageListener(importQuiz);

  return (
    <div
      style={{
        height:
          'calc(100vh - 139px )' /* @HACK this is to prevent duplicate scorllbars. 100% Height minus Header*/,
      }}
    >
      <iframe width="100%" height="100%" src={DISCOVER_URL}></iframe>
      <QuizzesPaywall
        open={quizLimitPaywallOpen}
        onClose={onCloseQuizLimitPaywall}
        paywallTouch={touch}
      />
    </div>
  );
}
